module.exports = __webpack_public_path__ + "static/media/snaphabit-icon.c6cac463.png";